module.exports = __webpack_public_path__ + "static/img/peizi_logo.21af1b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/peizi_logo.png
// module id = jJvS
// module chunks = 1